/*
 * Application Insights JavaScript SDK - Common, 2.6.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Stack frame information.
 */
var StackFrame = /** @class */ (function () {
    function StackFrame() {
    }
    return StackFrame;
}());
export { StackFrame };
//# sourceMappingURL=StackFrame.js.map